import * as actionTypes from './actionTypes';

import axios from '../../util/axios-portals';

export const loadOrdersFail = (error) => {
    return {
        type: actionTypes.ORDER_GET_ORDERS_FROM_SERVER_FAIL, 
        error
    };
}

export const loadOrdersSuccess = (orders) => {
    return {
        type: actionTypes.ORDER_GET_ORDERS_FROM_SERVER_SUCCESS, 
        orders
    };
}

export const loadOrdersStart = () => {
    return {
        type: actionTypes.ORDER_GET_ORDERS_FROM_SERVER_START
    };
}

export const loadOrdersFromServer = (start, end, token) => {
    return (dispatch) => {
        dispatch(loadOrdersStart());

        axios.get(`/orders?start=${start}&end=${end}`, {
            headers: {
                'Authorization': `Bearer ${token}`, 
                'Accept': 'application/json'
            }
        })
        .then(response => dispatch(loadOrdersSuccess(response.data.orders)))
        .catch(err => dispatch(loadOrdersFail(err)));
    };
}

/***** LOAD SINGLE ORDER *****/
export const loadOrderFail = (error) => {
    return {
        type: actionTypes.ORDER_GET_ORDER_FROM_SERVER_FAIL, 
        error
    };
}

export const loadOrderSuccess = (stops, pay) => {
    return {
        type: actionTypes.ORDER_GET_ORDER_FROM_SERVER_SUCCESS, 
        stops, 
        pay
    };
}

export const loadOrderStart = () => {
    return {
        type: actionTypes.ORDER_GET_ORDER_FROM_SERVER_START
    };
}

export const loadOrderFromServer = (legNumber, token) => {
    return (dispatch) => {
        dispatch(loadOrderStart());

        axios.get(`/orders/view/${legNumber}`, {
            headers: {
                'Authorization': `Bearer ${token}`, 
                'Accept': 'application/json'
            }
        })
        .then(response => dispatch(loadOrderSuccess(response.data.stops, response.data.pay)))
        .catch(err => dispatch(loadOrderFail(err)));
    };
}